import { universalSearchReducer, UNIVERSAL_SEARCH_KEY } from '@zocdoc/components/src/universalsearch';
import { insurancePickerReducer, INSURANCE_PICKER_KEY } from '@zocdoc/components/src/InsurancePicker';
import { insuranceReducer, INSURANCE_STATE_KEY } from '@zocdoc/components/src/InsuranceForm';

import { ROOT_KEY } from './state/constants';
import { searchReducer } from './state';
import { seoReducer, SEO_KEY } from '../Shared/Seo';

import { abReducer } from '../config/ab/reducer';
import { AB_KEY } from '../config/ab/constants';

export default {
    [ROOT_KEY]: searchReducer,
    [UNIVERSAL_SEARCH_KEY]: universalSearchReducer,
    [INSURANCE_PICKER_KEY]: insurancePickerReducer,
    [INSURANCE_STATE_KEY]: insuranceReducer,
    [SEO_KEY]: seoReducer,
    [AB_KEY]: abReducer,
};
